<template>
  <article class="performer-movie-item">
    <iframe width="160" height="90" :src="'https://www.youtube.com/embed/' + videoUrl + '?playsinline=1'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <h3 class="performer-member-item-info-title">
      {{ title }}
    </h3>
  </article>
</template>

<script>
export default {
  props: {
    videoUrl: {
      type: String
    },
    title: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  .performer-movie-item {
    display: flex;

    iframe {
      margin-right: 10px;
    }

    p {
      color: #333;
      font-size: 14px;
    }

    .performer-member-item-info-title {
      font-size: 14px;
      color: #333;
      text-align: left;
      padding-bottom: 0;
      margin-bottom: 0;
      font-weight: normal;
    }
  }
</style>
